import { Component, createRef, ReactNode, RefObject } from 'react';
import Dialog, { Positions } from './Dialog';
import styles from './styles.scss';
import cn from 'classnames';
import { delay } from 'utils';

interface OwnProps {
  position?: Positions;
  defaultShow?: true;
  text: ReactNode;
  className?: string;
  contentClassName?: string;
  hoverText?: string;
  skipDefaultStyle?: boolean;
}

interface OwnState {
  show: boolean;
}

const TOOLTIP_DELAY = 50;

export class ToolTipDialog extends Component<OwnProps, OwnState> {
  private readonly parent: RefObject<HTMLElement>;
  private mouseOver = delay(TOOLTIP_DELAY);

  constructor(props: OwnProps) {
    super(props);
    this.state = {
      show: props.defaultShow || false
    };
    this.parent = createRef();
  }

  public componentWillUnmount(): void {
    this.mouseOver.cleanup();
  }

  public render() {
    const {
      props: { text, position, className, contentClassName, hoverText, skipDefaultStyle },
      state: { show }
    } = this;

    const tooltipHoverText = hoverText || '?';

    return (
      <div className={styles.toolTipWrapper}>
        <span
          className={cn({ [styles.tooltip]: !skipDefaultStyle }, className)}
          onMouseMove={this.handleHover}
          onMouseLeave={this.handleLeave}
          onClick={() => this.onClick}
          ref={this.parent}
        >
          {tooltipHoverText}
        </span>
        {show && (
          <Dialog
            className={contentClassName}
            parent={this.parent}
            text={text}
            position={position || 'top'}
            arrow
          />
        )}
      </div>
    );
  }

  private handleHover = () =>
    this.mouseOver.setDelay(() => this.state.show || this.setState(() => ({ show: true })));
  private handleLeave = () =>
    this.mouseOver.setDelay(() => this.state.show && this.setState(() => ({ show: false })));

  private onClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    this.state.show || this.setState(() => ({ show: !this.state.show }));
  };
}

interface ToolTipLinkProps {
  href: string;
}

export const ToolTipLink = ({ href }: ToolTipLinkProps) => {
  return (
    <a target="_blank" rel="noreferrer" className={styles.tooltip} href={href}>
      ?
    </a>
  );
};

interface ToolTipModalProps {
  onClick?: () => void;
}

export const ToolTipModal = ({ onClick }: ToolTipModalProps) => {
  return (
    <button className={styles.tooltip} onClick={onClick && onClick}>
      ?
    </button>
  );
};
